import { CoachingSwitchboardService } from '../../coaching-base/switchboard';
import {
    composeCommitmentSummaryItemIdentifier,
    StatusView,
    TabRefId,
} from '../../coaching-detail';
import { StatusViewType } from '../../coaching-detail/pillar-two/status-view-type.model';
import {
    ObservationCommitDialogItem,
    ObservationCommitDialogItemStatus,
} from '../../coaching-observation/observation-commit-dialog/observation-commit-dialog.component';
import { DraftIdByIdentifier } from '../../coaching-observation/observation/observation-focus-draft-id-identifier.model';

export function prepStatuses(
    published: boolean,
    dialogItems: ObservationCommitDialogItem[],
    switchboardService: CoachingSwitchboardService,
    draftIdByIdentifier: DraftIdByIdentifier,
): {
    statuses: StatusView[];
    promiseStatuses: (prom: Promise<any>) => Promise<any>;
} {
    const statusMap = {
        [ObservationCommitDialogItemStatus.UPDATED]: StatusViewType.UPDATED,
        [ObservationCommitDialogItemStatus.NEW]: StatusViewType.NEW,
    };
    const statuses: StatusView[] = [];
    if (published) {
        const nextStatuses = dialogItems
            .filter((e) => {
                return (
                    e.Status === ObservationCommitDialogItemStatus.UPDATED ||
                    e.Status === ObservationCommitDialogItemStatus.NEW
                );
            })
            .map<StatusView>((e) => {
                const nextCommitmentId =
                    e.Status === ObservationCommitDialogItemStatus.NEW
                        ? {
                              commitmentId: null,
                              draftId: draftIdByIdentifier[e.ID],
                          }
                        : {
                              commitmentId: e.commitmentId,
                              draftId: draftIdByIdentifier[e.ID],
                          };
                return {
                    which: TabRefId.COMMITMENTS,
                    id: composeCommitmentSummaryItemIdentifier(
                        nextCommitmentId,
                    ),
                    type: statusMap[e.Status],
                    identifier: e.ID,
                    active: undefined,
                };
            });
        statuses.push(...nextStatuses);
    }
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const promiseStatuses = (prom: Promise<any>): Promise<any> => {
        return (
            prom
                // eslint-disable-next-line @typescript-eslint/promise-function-async
                .then(() => {
                    return switchboardService.pillarTwo.connected()
                        ? switchboardService.pillarTwo.sbReload(null)
                        : // eslint-disable-next-line prefer-promise-reject-errors
                          Promise.reject();
                })
                // eslint-disable-next-line @typescript-eslint/promise-function-async
                .then(() => {
                    return switchboardService.pillarTwo.sbSetStatuses(statuses);
                })
                .catch(() => null)
        );
    };
    return { statuses, promiseStatuses };
}
